module.exports = __webpack_public_path__ + "img/flatten.f164a181.svg";